import { Trans } from '@lingui/react/macro';

type Props = {
  label: string;
  isSelected: boolean;
};

const AddOptionRow = ({ label, isSelected }: Props) => {
  return (
    <span className="flex items-baseline justify-start gap-2">
      {label}
      <span className="font-bold text-aqua-400 italic">
        {isSelected ? <Trans>(added)</Trans> : <Trans>(+ add)</Trans>}
      </span>
    </span>
  );
};

export default AddOptionRow;
